module.exports = "data:image/gif;base64,R0lGODlhFQAJAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAkAAAIXjI+AywnaYnhUMoqt3gZXPmVg94yJVQAAOw=="


//////////////////
// WEBPACK FOOTER
// ./source/javascripts/vendor/admin/js/libs/jquery.tablesorteskin/bg.gif
// module id = 588
// module chunks = 7 8 9 10